import { put } from 'api/client';
import config from 'config';

export const setPageAutoSchedule = (
  pageId: number,
  enabled: boolean,
): Promise<{ enabled: boolean }> => {
  return put<{ enabled: boolean }>(
    `/pages/${pageId}/settings/auto-schedule-on-approval`,
    { enabled },
    { baseURL: config.API_SERVICE_ENDPOINT },
  ).then((response) => ({ enabled: response.enabled }));
};
